import { useLocation } from "react-router-dom";

import qs from "qs";

// TODO: this is the chosen read primitive — migrate Hooks/useQueryParams.js
// callers to here and delete that file. Plain-object destructuring beats
// URLSearchParams.get(), and qs handles nested/array params that
// URLSearchParams botches. Write side (Utilities/urlParamHooks.js) is a
// separate consolidation.
const useUrlParams = () => {
  const { search } = useLocation();
  return qs.parse(search, {
    ignoreQueryPrefix: true,
  });
};

export default useUrlParams;
